import request from '@/utils/request'

export default {
  // 文件预览
  getFiles(data, type) {
    return request({
      url: `/file/queryFile`,
      method: 'post',
      data,
      fileFlag: type === 0 ? 0 : 1
    })
  }
}
